/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgRectangle02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "100%"}
    height={props.height || "100%"}
    fill="none"
    viewBox="0 0 132 24"
    data-name="SvgRectangle02"
    {...props}
  >
    {props.children}
    <path
      fill="#C9DDE9"
      d="M2.003.458h120.269c.519 0 1.002.26 1.288.693L130.716 12l-7.156 10.849a1.54 1.54 0 0 1-1.288.693H2.002c-1.23 0-1.965-1.373-1.282-2.398l5.927-8.89.17-.254-.17-.254L.72 2.856C.037 1.83.772.457 2.003.457"
    />
    <path
      fill="url(#rectangle02_svg__a)"
      fillOpacity={0.4}
      d="M2.003.458h120.269c.519 0 1.002.26 1.288.693L130.716 12l-7.156 10.849a1.54 1.54 0 0 1-1.288.693H2.002c-1.23 0-1.965-1.373-1.282-2.398l5.927-8.89.17-.254-.17-.254L.72 2.856C.037 1.83.772.457 2.003.457"
    />
    <path
      stroke="url(#rectangle02_svg__b)"
      strokeWidth={0.917}
      d="M2.003.458h120.269c.519 0 1.002.26 1.288.693L130.716 12l-7.156 10.849a1.54 1.54 0 0 1-1.288.693H2.002c-1.23 0-1.965-1.373-1.282-2.398l5.927-8.89.17-.254-.17-.254L.72 2.856C.037 1.83.772.457 2.003.457Z"
    />
    <defs>
      <linearGradient
        id="rectangle02_svg__a"
        x1={41.247}
        x2={46.312}
        y1={-2.907}
        y2={24.159}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="rectangle02_svg__b"
        x1={9.488}
        x2={12.526}
        y1={0.45}
        y2={28.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.7} />
        <stop offset={0.406} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={0.574} stopColor="#fff" stopOpacity={0.01} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.4} />
      </linearGradient>
    </defs>
  </svg>
)
